import { Icons, iconColors } from "./icons";
import React, { useState } from "react";
import { auth, db } from "./firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate, useLocation } from "react-router-dom";
import "./Login.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errore, setErrore] = useState("");
  const [successo, setSuccesso] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    if (location.state?.email) {
      setEmail(location.state.email);
    }
  }, [location.state]);

  const routes = {
    admin: "/dashboard-admin",
    gestore: "/dashboard-gestore",
    cassa: "/dashboard-cassa",
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrore("");
    setSuccesso("");
    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const uid = userCredential.user.uid;

      const docRef = doc(db, "utenti", uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const userData = docSnap.data();
        const ruolo = userData.ruolo?.toLowerCase()?.trim();

        // Admin sempre libero
        if (ruolo !== "admin") {
          const localeAssociato =
            userData.localeTag ||
            (Array.isArray(userData.locali) ? userData.locali[0] : null);

          if (localeAssociato) {
            const localeRef = doc(db, "locali", localeAssociato);
            const localeSnap = await getDoc(localeRef);

            if (localeSnap.exists()) {
              const localeData = localeSnap.data();

              if (localeData.stato === "bloccato") {
                if (localeData.trialExpired === true) {

  setErrore("__DEMO_SCADUTA__");

} else {

  setErrore("__LOCALE_BLOCCATO__");

}                setLoading(false);
                return;
              }
            }
          }
        }

        const target = routes[ruolo] || "/";
        navigate(target);
      } else {
        setErrore("⚠️ Nessun ruolo associato al tuo account.");
      }
    } catch (error) {
      const code = error?.code || "";

      if (code.includes("auth/wrong-password") || code.includes("auth/user-not-found")) {
        setErrore("❌ Email o password errate.");
      } else if (code.includes("auth/too-many-requests")) {
        setErrore("⏳ Troppe richieste. Riprova più tardi.");
      } else {
        setErrore("❌ Errore login.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    if (loading) return;

    if (!email) {
      setErrore("⚠️ Inserisci prima la tua email.");
      return;
    }

    setErrore("");
    setSuccesso("");
    setLoading(true);

    try {
      const functions = getFunctions(undefined, "europe-west1");
      const sendReset = httpsCallable(functions, "sendResetEmail");

      await sendReset({ email });

      setSuccesso("📩 Se l'email è registrata riceverai un messaggio.");
      setPassword("");

    } catch (error) {
      console.error(error);
      setErrore("❌ Errore invio email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-card">

        <div className="brand">
          <div className="logo-icon">
            <img src="/logo-quadrato.png" alt="QrMenu" />
          </div>
          <h1>QrMenu</h1>
        </div>

        <p className="subtitle">Accedi al tuo account</p>

        <form onSubmit={handleLogin} className="login-form">

          <div className="input-group">
            <label>Email</label>
            <input
              type="email"
              placeholder="es. nome@esempio.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              required
            />
          </div>

          <div className="input-group">
            <label>Password</label>

            <div className="password-row">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="La tua password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
                required
              />

              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword((s) => !s)}
              >
                {showPassword ? (
                  <Icons.eyeOff color={iconColors.neutral} />
                ) : (
                  <Icons.eye color={iconColors.neutral} />
                )}
              </button>
            </div>
          </div>

          <button className="primary-btn" disabled={loading}>
            {loading ? "Accedendo..." : "Accedi"}
          </button>
        </form>

        {errore === "__DEMO_SCADUTA__" ? (

          <div className="blocked-box">

            <div className="blocked-icon">
              🎭
            </div>

            <h3>Demo terminata</h3>

            <p>
              La tua prova gratuita di QrMenu è terminata.
            </p>

            <button
              className="blocked-btn"
              onClick={() => {
                window.location.href = "/contatti";
              }}
            >
              🚀 Attiva QrMenu
            </button>

          </div>

        ) : errore === "__LOCALE_BLOCCATO__" ? (

          <div className="blocked-box">

            <div className="blocked-icon">
              🚫
            </div>

            <h3>Locale disattivato</h3>

            <p>
              Contatta l’amministratore.
            </p>

          </div>

        ) : errore ? (

          <div className="error">
            {errore}
          </div>

        ) : null}
        {successo && <div className="success">{successo}</div>}

        <div className="help-row">
          <button
            type="button"
            className="reset-btn"
            onClick={handleResetPassword}
            disabled={loading}
          >
            Hai dimenticato la password?
          </button>
        </div>

      </div>
    </div>
  );
}

export default Login;